import React from 'react'

function Address() {
  return (
    <div>   <svg
    width="28"
    height="28"
    viewBox="0 0 28 28"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="28" height="28" rx="14" fill="#5B1DEE" />
    <g filter="url(#filter0_d_1159_51576)">
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M17.1668 11.7462L18.4822 11.3078C18.6601 11.2485 18.8556 11.2783 19.0077 11.3879C19.1599 11.4976 19.25 11.6737 19.25 11.8612V17.6945C19.25 17.9456 19.0893 18.1685 18.8511 18.2479L15.9345 19.2201C15.8147 19.26 15.6853 19.26 15.5655 19.2201L12.4345 18.1764C12.3147 18.1365 12.1853 18.1365 12.0655 18.1764L9.5178 19.0257C9.33991 19.085 9.14437 19.0551 8.99225 18.9455C8.84014 18.8359 8.75 18.6598 8.75 18.4723V12.6389C8.75 12.3879 8.91067 12.165 9.14887 12.0856L10.8014 11.5347"
        fill="white"
      />
      <path
        d="M17.1668 11.7462L18.4822 11.3078C18.6601 11.2485 18.8556 11.2783 19.0077 11.3879C19.1599 11.4976 19.25 11.6737 19.25 11.8612V17.6945C19.25 17.9456 19.0893 18.1685 18.8511 18.2479L15.9345 19.2201C15.8147 19.26 15.6853 19.26 15.5655 19.2201L12.4345 18.1764C12.3147 18.1365 12.1853 18.1365 12.0655 18.1764L9.5178 19.0257C9.33991 19.085 9.14437 19.0551 8.99225 18.9455C8.84014 18.8359 8.75 18.6598 8.75 18.4723V12.6389C8.75 12.3879 8.91067 12.165 9.14887 12.0856L10.8014 11.5347"
        stroke="black"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </g>
    <path
      d="M12.2507 16.3334V18.1465"
      stroke="black"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M15.7507 16.3334V19.25"
      stroke="black"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M17.2077 11.3373C17.187 9.58014 15.7567 8.1665 13.9993 8.1665C12.242 8.1665 10.8117 9.58014 10.791 11.3373C10.791 12.6145 12.0514 13.968 12.9921 14.8007C13.5746 15.2885 14.4229 15.2886 15.0056 14.801C15.947 13.9685 17.2077 12.6147 17.2077 11.3373Z"
      fill="white"
      stroke="black"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M13.1257 10.3541V12.3958"
      stroke="black"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M14.8757 10.3541V12.3958"
      stroke="black"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M13.125 11.375H14.875"
      stroke="black"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <defs>
      <filter
        id="filter0_d_1159_51576"
        x="8.25"
        y="10.7778"
        width="12.5"
        height="9.97217"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB"
      >
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dx="1" dy="1" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 1 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_1159_51576"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_1159_51576"
          result="shape"
        />
      </filter>
    </defs>
  </svg></div>
  )
}

export default Address